module.exports = __webpack_public_path__ + "media/images/spinner-5bb9971803dcb1d30026bfae9aa5745f.gif";